import React from 'react';
import styles from './PromotionsSection.module.css';

const PromotionsSection = () => {
  const promotions = [
    {
      id: 1,
      title: '🎉 Bono de Bienvenida',
      description: '¡Regístrate ahora y recibe $1000 gratis para tu primer sorteo!',
      background: 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/notificacion%2F_a172c843-68c5-46fd-826d-9c4ed8dfc0f1.jpeg?alt=media&token=568de337-0df6-4398-970c-c3e6a2b83add',
    },
    {
      id: 2,
      title: '💵 Bono del 100% en la Primera Recarga',
      description: 'Duplica tu saldo con tu primera recarga. ¡Más oportunidades para ganar!',
      background: 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/sorteos%2FOIG2.jpeg?alt=media&token=2a1d0adb-ebe4-4ab8-9ef2-7e2d40d1770b',
    },
    {
      id: 3,
      title: '🔁 Sorteos Diarios',
      description: 'Participa todos los días y duplica tus posibilidades de ganar.',
      background: 'https://firebasestorage.googleapis.com/v0/b/megaloto-express.appspot.com/o/sorteos%2F_cd91d55d-08fb-439f-b87f-b4e4bc663da3.jpeg?alt=media&token=72a44c44-5f90-427b-bd80-57124b35840c',
    },
  ];
 const click = ()=>{
   window.location.href = '/dashboard';
 }
  return (
    <section className={styles.promotions}>
      <h2 className={styles.title}>Promociones Exclusivas</h2>
      <div className={styles.cards}>
        {promotions.map((promo) => (
          <div
            key={promo.id}
            className={styles.card}
            style={{ backgroundImage: `url(${promo.background})` }}
          >
            <div className={styles.overlay}>
              <h3>{promo.title}</h3>
              <p>{promo.description}</p>
              <button className={styles.cta} onClick={click}>Aprovechar ahora</button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default PromotionsSection;
